"use client";

import { useTheme, useMediaQuery, Typography, Grid } from "@mui/material";
import { pxToVw } from "@/utils/pxToVw";
import { MOBILE_BASE } from "@/theme/theme";
import Image from "next/image";
import React from "react";
import StickyImage from "./StickyImage";
import { useText } from "@/context/TextContext";

export default function ComTreballemSection() {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("md"));

  const comTreballem = [
    {
      title: useText("lloguer.comtreballem.title"),
      content: useText("lloguer.comtreballem.text"),
    },
    {
      title: useText("lloguer.transport.title"),
      content: useText("lloguer.transport.text"),
    },
    {
      title: useText("lloguer.muntatge.title"),
      content: useText("lloguer.muntatge.text"),
    },
    {
      title: useText("lloguer.neteja.title"),
      content: useText("lloguer.neteja.text"),
    },
    {
      title: useText("lloguer.qualitat.title"),
      content: useText("lloguer.qualitat.text"),
    },
  ];

  const stickyImage = useText("lloguer.image.sticky");

  return (
    <Grid
      container
      mt={{ xs: pxToVw(30, MOBILE_BASE), md: pxToVw(0) }}
      mb={{ xs: pxToVw(80, MOBILE_BASE), md: pxToVw(100) }}
      flexDirection={{ xs: "column-reverse", md: "inherit" }}
    >
      <Grid container size={{ xs: 12, md: 4 }}>
        {!isMobile && (
          <StickyImage
            width={344}
            height={445}
            alt="Com treballem"
            src={stickyImage}
          />
        )}
        {isMobile && (
          <Image
            alt="Com treballem"
            src={stickyImage}
            width={344}
            height={445}
            style={{
              width: "100%",
              height: "fit-content",
            }}
          />
        )}
      </Grid>
      <Grid
        container
        size={{ xs: 12, md: 5 }}
        offset={{ xs: 0, md: 3 }}
        direction={"column"}
      >
        {comTreballem.map((item, index) => (
          <React.Fragment key={index}>
            <Typography
              variant="titulo"
              color="marron"
              component="h2"
              sx={{ textTransform: "uppercase" }}
            >
              {item.title}
            </Typography>
            <Typography
              variant="body3"
              color="marron"
              mt={{ xs: pxToVw(6, MOBILE_BASE), md: pxToVw(8) }}
              mb={{ xs: pxToVw(30, MOBILE_BASE), md: pxToVw(60) }}
              dangerouslySetInnerHTML={{ __html: item.content }}
            />
          </React.Fragment>
        ))}
      </Grid>
    </Grid>
  );
}
